<div class="warning-tile">
    <div class="content">
        <ng-content></ng-content>
    </div>
</div>
